import { ConfigProvider, App } from "antd";
import themeConfig from "./config/themeConfig";
import store from "./redux/store";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import router from "./router/Router";
import IdleTimerModal from "./components/Auth/IdleTimerModal";
import '@ant-design/v5-patch-for-react-19';

const AppComponent = () => {
  return (
    <ConfigProvider theme={themeConfig}>
      <Provider store={store}>
        <App>
          <IdleTimerModal>
            <RouterProvider
              future={{
                v7_startTransition: true,
              }}
              router={router}
            />
          </IdleTimerModal>
        </App>
      </Provider>
    </ConfigProvider>
  );
};

export default AppComponent;
